import Head from "next/head";

import config from "config";
import { AuthLayout } from "auth";

import * as appConfig from "data-apps/sales-forecasting/config";
import ProjectListing from "data-apps/sales-forecasting/Listing";

const ProjectListingPage = () => {
  return <ProjectListing />;
};

ProjectListingPage.getLayout = (page) => (
  <>
    <Head>
      <title>
        {config.SITE_NAME} | {appConfig.APP_NAME}
      </title>
    </Head>
    {/* We want users to still see their files. */}
    <AuthLayout stopExpiredUsers={false}>{page}</AuthLayout>
  </>
);

export default ProjectListingPage;
